import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/tech-trends/tieng-anh-giao-tiep/TiengAnhClient.tsx");
